import React from 'react';
import {
  AnalyticsWidgetWrapper,
  AnalyticsConnector,
  AnalyticsCard,
  AnalyticsTitle,
  AnalyticsRow,
  AnalyticsLabel,
  AnalyticsValue,
  AnalyticsRate,
} from './FlowBuilder.styles';

const WIDGET_TYPES = new Set([
  'send_message',
  'send_connection',
  'check_connection',
  'send_email',
  'email_finder',
]);

const pct = (value, base) => {
  if (!base || base === 0) return null;
  return Math.round((value / base) * 100) + '%';
};

const NodeAnalyticsWidget = ({ nodeType, analytics, nodeStats }) => {
  if (!WIDGET_TYPES.has(nodeType)) return null;

  const data = analytics || {};
  const sent = data.sent ?? nodeStats?.completed ?? 0;

  let rows;
  if (nodeType === 'send_message') {
    rows = [
      { label: 'Sent', value: sent, rate: null, color: '#3b82f6' },
      { label: 'Opened', value: data.opened ?? 0, rate: pct(data.opened ?? 0, sent), color: '#8b5cf6' },
      { label: 'Replied', value: data.replied ?? 0, rate: pct(data.replied ?? 0, sent), color: '#22c55e' },
    ];
  } else if (nodeType === 'send_connection') {
    rows = [
      { label: 'Sent', value: sent, rate: null, color: '#3b82f6' },
      { label: 'Accepted', value: data.accepted ?? 0, rate: pct(data.accepted ?? 0, sent), color: '#22c55e' },
    ];
  } else if (nodeType === 'send_email') {
    rows = [
      { label: 'Sent', value: data.sent ?? sent, rate: null, color: '#3b82f6' },
      { label: 'Opened', value: data.opened ?? 0, rate: pct(data.opened ?? 0, data.sent ?? sent), color: '#8b5cf6' },
      { label: 'Clicked', value: data.clicked ?? 0, rate: pct(data.clicked ?? 0, data.sent ?? sent), color: '#2563eb' },
      { label: 'Replied', value: data.replied ?? 0, rate: pct(data.replied ?? 0, data.sent ?? sent), color: '#22c55e' },
    ];
  } else if (nodeType === 'email_finder') {
    const found = data.found ?? 0;
    const notFound = data.notFound ?? 0;
    const processed = found + notFound;
    rows = [
      { label: 'Emails Identified', value: found, rate: pct(found, processed), color: '#22c55e' },
      { label: 'No Valid Email', value: notFound, rate: pct(notFound, processed), color: '#94a3b8' },
    ];
  } else {
    const connected = data.connected ?? 0;
    const notConnected = data.notConnected ?? 0;
    const total = connected + notConnected;
    rows = [
      { label: 'Connected', value: connected, rate: pct(connected, total), color: '#22c55e' },
      { label: 'Not Connected', value: notConnected, rate: pct(notConnected, total), color: '#94a3b8' },
    ];
  }

  const allZero = rows.every(r => r.value === 0);

  return (
    <AnalyticsWidgetWrapper>
      <AnalyticsConnector />
      <AnalyticsCard>
        <AnalyticsTitle>Analytics</AnalyticsTitle>
        {rows.map(r => (
          <AnalyticsRow key={r.label}>
            <AnalyticsLabel>{r.label}</AnalyticsLabel>
            <span style={{ display: 'flex', alignItems: 'baseline', gap: '2px' }}>
              <AnalyticsValue $color={allZero ? '#cbd5e1' : r.color}>
                {r.value}
              </AnalyticsValue>
              {r.rate !== null && (
                <AnalyticsRate $color={allZero ? '#cbd5e1' : r.color}>
                  {r.rate}
                </AnalyticsRate>
              )}
            </span>
          </AnalyticsRow>
        ))}
      </AnalyticsCard>
    </AnalyticsWidgetWrapper>
  );
};

export default NodeAnalyticsWidget;
